import React, { useEffect, useState } from 'react';
import { BASEAPIURL, token } from '../env';

const NoticeList = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch notices from API
  useEffect(() => {
    const fetchNotices = async () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "tokenData": token
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      try {
        console.log("Using token:", token); // Debugging token value

        const response = await fetch(`${BASEAPIURL}/GetNotice`, requestOptions);

        if (!response.ok) {
          throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();

        console.log("API Response:", data); // Log the entire API response for debugging

        // Case 2: If the response is an object with a 'data' field containing notices
        if (data && data.data && Array.isArray(data.data)) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // Normalize time to start of day for accurate comparison

          const filteredNotices = data.data.filter(notice => {
            const endDate = new Date(notice.EndDate);
            endDate.setHours(0, 0, 0, 0); // Normalize end date too
            return endDate >= today;
          });

          setNotices(filteredNotices);
        } else {
          console.error("Unexpected response format:", data);
          setNotices([]);  // Set empty array if format is unexpected
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching notices:", error);
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  // Debugging output for notices state
  console.log("Notices state:", notices);

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Notices</h1>

      {loading ? (
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : notices.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>S.No</th>
                <th>Heading</th>
                <th>Description</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Document</th>
              </tr>
            </thead>
            <tbody>
              {notices.map((notice, index) => (
                <tr key={notice.SNo || notice.id || index}>
                  <td>{index + 1}</td>
                  <td>{notice.Heading}</td>
                  <td>{notice.Description}</td>
                  <td>{new Date(notice.StartDate).toLocaleDateString()}</td>
                  <td>{new Date(notice.EndDate).toLocaleDateString()}</td>
                  <td>
                    {notice.Document ? (
                      <div>
                        {notice.Document.endsWith(".pdf") && (
                          <iframe
                            src={notice.Document}
                            width="100%"
                            height="200"
                            title="Notice Document"
                            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                          ></iframe>
                        )}
                        <a
                          href={notice.Document}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-outline-primary mt-2"
                          download
                        >
                          Download
                        </a>
                      </div>
                    ) : (
                      <span className="text-muted">No Document</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p className="text-center">No notices available</p>
      )}
    </div>
  );
};

export default NoticeList;